var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrganization(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.66667V0H13.3333V2.66667H15.3333C15.7015 2.66667 16 2.96514 16 3.33333V15.3333C16 15.7015 15.7015 16 15.3333 16L0 16V2.12773L8.24761 0.360379C9.49263 0.0935879 10.6667 1.04269 10.6667 2.31598V2.66667H12ZM10.6667 4V14.6667L14.6667 14.6667V12.6667H12.6667V11.3333H14.6667V10H12.6667V8.66667H14.6667V7.33333H12.6667V6H14.6667V4H10.6667ZM9.33333 14.6667V2.31598C9.33333 1.89155 8.94199 1.57518 8.52698 1.66412L1.33333 3.20561V14.6667H3.33333V12H7.33333V14.6667H9.33333ZM6 14.6667V13.3333H4.66667V14.6667H6ZM4.66667 5.33333H2.66667V4H4.66667V5.33333ZM8 5.33333H6V4H8V5.33333ZM4.66667 8H2.66667V6.66667H4.66667V8ZM8 8H6V6.66667H8V8ZM4.66667 10.6667H2.66667V9.33333H4.66667V10.6667ZM8 10.6667H6V9.33333H8V10.6667Z",
    fill: "#EFF3F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/Organization.028995e77641fc2242cdcf500528034a.svg";
export { ForwardRef as ReactComponent };